import { normalizeSitePath, type PageMeta } from '../../lib/seo';
import { COMPARISONS } from '../comparisons';
import type { MarketingPageContent, RelatedLink } from './types';
import {
  // AI_PREVIZ_META,
  AI_VIDEO_CONTINUITY_META,
  BLOG_META,
  FAQ_META,
  FOR_AGENCIES_META,
  FOR_ENTERPRISE_META,
  FOR_CREATORS_META,
  FOR_FILMMAKERS_META,
  HOME_META,
  NOT_FOUND_META,
  PRICING_META,
  PRIVACY_META,
  PRODUCT_MODELS_META,
  PRODUCT_SCRIPT_META,
  PRODUCT_SHOT_CONTROL_META,
  RHAPSODY_META,
  // SCRIPT_TO_VIDEO_META,
  SHOWREEL_META,
  TERMS_META,
  WHAT_IS_INDUCE_META,
} from '../../lib/seo';
import { FOR_FILMMAKERS_CONTENT } from './forFilmmakers';
import { FOR_AGENCIES_CONTENT } from './forAgencies';
import { FOR_CREATORS_CONTENT } from './forCreators';
// import { SCRIPT_TO_VIDEO_CONTENT } from './scriptToVideo';
import { AI_VIDEO_CONTINUITY_CONTENT } from './aiVideoContinuity';
// import { AI_PREVIZ_CONTENT } from './aiPreviz';

export type PageRegistryEntry = {
  path: string;
  meta: PageMeta;
  prerender: boolean;
  sitemap: boolean;
  content?: MarketingPageContent;
  relatedLinks?: RelatedLink[];
};

const CORE_LINKS: RelatedLink[] = [
  { label: 'Script Editor', to: '/product/script-editor' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'FAQ', to: '/faq' },
];

function withRelated(extra: RelatedLink): RelatedLink[] {
  return [...CORE_LINKS, extra];
}

export const PAGE_REGISTRY: PageRegistryEntry[] = [
  { path: '/', meta: HOME_META, prerender: true, sitemap: true },
  { path: '/what-is-induce', meta: WHAT_IS_INDUCE_META, prerender: true, sitemap: true },
  { path: '/rhapsody', meta: RHAPSODY_META, prerender: true, sitemap: true },
  { path: '/product/script-editor', meta: PRODUCT_SCRIPT_META, prerender: true, sitemap: true },
  {
    path: '/product/ai-video-continuity',
    meta: AI_VIDEO_CONTINUITY_META,
    prerender: true,
    sitemap: true,
    content: AI_VIDEO_CONTINUITY_CONTENT,
    relatedLinks: withRelated({ label: 'Shot Control', to: '/product/shot-control' }),
  },
  { path: '/product/shot-control', meta: PRODUCT_SHOT_CONTROL_META, prerender: true, sitemap: true },
  { path: '/product/models', meta: PRODUCT_MODELS_META, prerender: true, sitemap: true },
  { path: '/pricing', meta: PRICING_META, prerender: true, sitemap: true },
  { path: '/faq', meta: FAQ_META, prerender: true, sitemap: true },
  { path: '/showreel', meta: SHOWREEL_META, prerender: true, sitemap: true },
  {
    path: '/for-filmmakers',
    meta: FOR_FILMMAKERS_META,
    prerender: true,
    sitemap: true,
    content: FOR_FILMMAKERS_CONTENT,
    relatedLinks: withRelated({ label: 'Continuity Engine', to: '/product/ai-video-continuity' }),
  },
  {
    path: '/for-agencies',
    meta: FOR_AGENCIES_META,
    prerender: true,
    sitemap: true,
    content: FOR_AGENCIES_CONTENT,
    relatedLinks: withRelated({ label: 'For Creators', to: '/for-creators' }),
  },
  {
    path: '/for-enterprise',
    meta: FOR_ENTERPRISE_META,
    prerender: true,
    sitemap: true,
    relatedLinks: withRelated({ label: 'For Agencies', to: '/for-agencies' }),
  },
  {
    path: '/for-creators',
    meta: FOR_CREATORS_META,
    prerender: true,
    sitemap: true,
    content: FOR_CREATORS_CONTENT,
    relatedLinks: withRelated({ label: 'For Filmmakers', to: '/for-filmmakers' }),
  },
  // {
  //   path: '/use-cases/script-to-video',
  //   meta: SCRIPT_TO_VIDEO_META,
  //   prerender: true,
  //   sitemap: false,
  //   content: SCRIPT_TO_VIDEO_CONTENT,
  //   relatedLinks: withRelated({ label: 'AI Video Continuity', to: '/product/ai-video-continuity' }),
  // },
  // {
  //   path: '/use-cases/ai-previz',
  //   meta: AI_PREVIZ_META,
  //   prerender: true,
  //   sitemap: false,
  //   content: AI_PREVIZ_CONTENT,
  //   relatedLinks: withRelated({ label: 'Script to Video', to: '/use-cases/script-to-video' }),
  // },
  { path: '/privacy-policy', meta: PRIVACY_META, prerender: true, sitemap: true },
  { path: '/terms-of-service', meta: TERMS_META, prerender: true, sitemap: true },
  { path: '/blog', meta: BLOG_META, prerender: true, sitemap: true },
  ...Object.values(COMPARISONS).map(({ meta }) => ({ path: meta.path, meta, prerender: true, sitemap: true })),
  { path: '/404', meta: NOT_FOUND_META, prerender: true, sitemap: false },
];

export const PRERENDER_ROUTES = PAGE_REGISTRY.filter((p) => p.prerender).map((p) => p.path);

export const SITEMAP_PATHS = PAGE_REGISTRY.filter((p) => p.sitemap).map((p) => p.path);

export function getPageMetaForPath(url: string): PageMeta {
  const path = normalizeSitePath(url);
  const registered = PAGE_REGISTRY.find((p) => p.path === path)?.meta;
  if (registered) return registered;
  if (path.startsWith('/blog/') && path !== '/blog') return BLOG_META;
  return NOT_FOUND_META;
}

export type { MarketingPageContent, RelatedLink } from './types';
